'use client';

import React from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { trackLearnHubModuleClick } from '@/lib/gaEvents';

// Paid-module destinations — clicks on these are tracked for enrollment attribution
const PAID_HREFS = new Set([
  '/free-lesson-screen',
  '/conversion-page',
  '/module/1',
  '/module/2',
  '/module/3',
  '/module/4',
  '/module/5',
  '/module/6',
  '/module/7',
  '/module/8',
  '/module/9',
]);

interface CardProps {
  title: string;
  description: string;
  href: string;
}

export function LearnCard({ title, description, href }: CardProps) {
  function handleClick() {
    if (PAID_HREFS.has(href)) {
      trackLearnHubModuleClick({
        article_slug: href.replace(/^\//, ''),
        article_title: title,
        module_href: href,
      });
    }
  }

  return (
    <Link
      href={href}
      onClick={handleClick}
      className="group block rounded-xl border p-6 transition-all duration-200 hover:shadow-md"
      style={{ backgroundColor: 'white', borderColor: 'rgba(27,42,74,0.12)' }}
    >
      <h3
        className="font-display font-semibold mb-2 group-hover:underline"
        style={{ fontSize: '1rem', color: '#1B2A4A', lineHeight: '1.4' }}
      >
        {title}
      </h3>
      <p className="font-body text-sm" style={{ color: '#6b7280', lineHeight: '1.6' }}>
        {description}
      </p>
      <div className="mt-4 flex items-center gap-1.5">
        <span className="font-body text-xs font-semibold" style={{ color: '#D4891A' }}>Read →</span>
      </div>
    </Link>
  );
}

export function LearnHubCTA() {
  function handleClick() {
    trackLearnHubModuleClick({
      article_slug: 'learn-hub-cta',
      article_title: 'Try the course — first two lessons free',
      module_href: '/free-lesson-screen',
    });
  }

  return (
    <Link
      href="/free-lesson-screen"
      onClick={handleClick}
      className="group inline-flex items-center justify-center gap-2.5 font-body font-semibold text-base px-8 py-4 rounded-xl transition-all duration-200 active:scale-95"
      style={{ backgroundColor: '#D4891A', color: 'white' }}
    >
      Try the course — first two lessons free
      <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
    </Link>
  );
}
